import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { SortDataService } from './../../core/services/sortdata';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { consultantalreadyassociated, emplyeealreadyassociated, fileTypeExtention, salaryalreadyassociated, serverError, suplieralreadyassociated } from './../../core/models/messages';
import {
  linkedCompanyRegExp,
  linkedInRegExp,
  patternEmail,
  patternNumbersOnly,
  urlRegExp,
} from './../../core/models/pattern';
import { FournisseurService } from './../../core/services/fournisseur-service/fournisseur.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Country, State, IState } from 'country-state-city';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as saveAs from 'file-saver';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { catchError, debounceTime, distinctUntilChanged, Subject, switchMap, takeUntil } from 'rxjs';
import { headerColumns20 } from './../../core/models/fournisseur';
import { PhoneNumberFormat } from 'ngx-intl-telephone-input';
import Swal from 'sweetalert2';
import { translations } from '@core/models/call-offer';

@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.css'],
})
export class SupplierComponent {
  isCollapsed = true;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
  idSupplier!: number;
  formfournisseur: FormGroup = this.createFormesn();
  formfournisseurind: FormGroup = this.createFormindivi();
  isexiste = false;
  idclientConnected: any;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  currentSortDirection: number = 1;
  private unsubscribeAll: Subject<void> = new Subject();
  type: any = [];
  date: Date[] | undefined;
  today = new Date();
  currentDate: string;
  searchInputSubject = new Subject<string>();
  isLoadSpinner: boolean = true;

  typee: any;
  startIndex: number = 0;
  modalRef?: BsModalRef;
  endIndex: number = 5;
  totalItems!: number;
  selectedFile: File | null = null;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  listfournisseurs: any[]=[];
  sortAttr = '';
  fileBulkError: any;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  fileExtentions: string = '';
  fournisseur_id: any;
  detailfournisseur: any;
  addBulk!: FormGroup;
  mode: string = 'create_supplier';
  checkboxStates: { [key: string]: boolean } = { '1': true, '2': true };
  currentSortColumn: string = 'name'; // Initial column to sort by
  searchForm: FormGroup = this.createSearchForm();
  types = [
    { id: '2', name: 'ESN' },
    { id: '5', name: 'Individuel' },
  ];
  fileErr: boolean = false;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];

  separateDialCode: boolean = false;
  stateList!: IState[];

  selectedType: any;
  url: string = environment.baseUrl + '/api';
  datepickerConfig = {
    dateInputFormat: 'YYYY',
    showYearPicker: true,
    isAnimated: true,
  };
  annee!: number;
  linkedin_link: any;
  annees: number[] = [];
  disabledCalendar: boolean = true;
  dataFourn: any;
  data: any[] = [
    {
      competences: [
        'nom',
        'site_web',
        'linkedin',
        'taille_entreprise',
        'pays',
        'localisation',
        'domaine',
        'annee_creation',
        'nom_vis_a_vis',
        'prenom_vis_a_vis',
        'mail_vis_a_vis',
        'num_vis_a_vis',
        'nombre_jours_de_prestation',
      ],
    },
  ];
  PhoneNumberFormat = PhoneNumberFormat;
  isPhoneEnabled: boolean = true;
  pagination : boolean =false;
  dataHeader: any = [];
  phoneForm: FormGroup = this.createFormPhone();
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns20;
  listNamesIndiv: any[] = [{ name: 'Image', item: 'image' }, { name: 'Nom', item: 'first_name' }];
  private searchTerms = new Subject<string>();

  listNames: string[] = [];
  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private fournisseurservice: FournisseurService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private sortDataService: SortDataService,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,

  ) {
    const day = String(this.today.getDate()).padStart(2, '0');
    const month = String(this.today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
    this.searchMail();
   
  }

  ngOnInit() {
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');
    this.sortType({ target: { value: '1', checked: true } }); // Cocher la case pour le type "2"
    this.setValidatorRequirements();
    this.getListElementHeader();
  


    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchName) => {
          const data = {
            search: searchName.trim().toLowerCase(),
          };
          console.log(
            '%centreprises.component.ts line:203 data search',
            'color: #007ACC;',
            data
          );
          return this.fournisseurservice.getfournisseurbyname(data.search, this.idclientConnected).pipe(
            catchError(() => {
              this.clearForm();            


              return [];
            })
          );
        })
      )
      .subscribe((res: any) => {
        if (res.status === 200 && res.data.id) {
          console.log('reponse', res);
          this.isexiste = true;
          this.fournisseur_id = res.data.id;
          this.formfournisseur.patchValue({
            linkedin_link: res.data.linkedin_link,
            website_link: res.data.website_link,
            year_of_creation: res.data.year_of_creation,
            address:res.data.city,
            country:res.data.country,
            domain: res.data.domain,
            type: res.data.type,
            fournisseur_id: res.data.id,
            ContactEmail: res.data.ContactEmail,
          });
          this.disableFormFields();
        } else {
          this.clearForm();
          this.enableFormFields()

        }
      });
  }
  createFormPhone(data?: any) {
    return this.formBuilder.group({
      phone: [data && data.phone],
    });
  }
  disableEvent(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
  translateCountryName(name: string): string {

    return translations[name] || name;
  }
  createFormesn(data?: any) {
    return this.formBuilder.group({
      clientFinal_id: [''],
      fournisseur_id: [''],
      client_id: [''],
      type: [2],
      name: [data ? data.name : '', [Validators.required]],
      ContactEmail: [
        data ? data.ContactEmail : '',
        [Validators.email, Validators.pattern(patternEmail)],
      ],
      linkedin_link: ['', [Validators.pattern(linkedCompanyRegExp)]],
      website_link: [data ? data.website_link : "", [Validators.pattern(urlRegExp)]],
      country: [data ? data.country : null],
      address: [data ? data.address : null],
      related_first_name_client: [data ? data.related_first_name_client : ''],
      related_last_name_client: [data ? data.related_last_name_client : ''],
      year_of_creation: [
        data ? new Date(data.year_of_creation).getFullYear().toString() : '',
      ],
      related_email_client: [
        data ? data.related_email_client : null,
        [Validators.email, Validators.pattern(patternEmail)],
      ],
      related_phone_client: [data ? data.related_phone_client : null],
      nb_days: [
        data ? data.nb_days : '',
        [Validators.pattern(patternNumbersOnly)],
      ],
      date_first_presentation: [data ? data.date_first_presentation : ''],
    });
  }


  createFormindivi(data?: any) {
    return this.formBuilder.group({
      clientFinal_id: [''],
      fournisseur_id: [''],
      client_id: [''],
      type: [5],
      fournisseur_first_name: [
        data ? data.fournisseur_first_name : '',
        [Validators.required],
      ],
      fournisseur_last_name: [
        data ? data.fournisseur_last_name : '',
        [Validators.required],
      ],
      linkedin_link: [data ? data.linkedin_link : '', [Validators.pattern(linkedInRegExp)]],
      fournisseur_email: [data ? data.fournisseur_email : '', [Validators.required, Validators.email, Validators.pattern(patternEmail)]],
      fournisseurPhone: [
        data ? data.fournisseurPhone : null,

      ],
      // nb_days: [
      //   data ? data.nb_days : '',
      //   [Validators.pattern(patternNumbersOnly)],
      // ],
      // date_first_presentation: [data ? data.date_first_presentation : ''],
    });
  }
  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formfournisseur.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }
  blockSpace(event: KeyboardEvent) {
  if (event.code === 'Space') {
    event.preventDefault();
    
  }
}

  closeModal() {
    this.stateList=[];
    this.enableFormFieldsIndiv();
    this.enableFormFieldsUpdate()
    this.formfournisseur.reset();
    this.formfournisseurind.reset();
    this.phoneForm.reset();
    this.modalRef!.hide();
  }
 
  setValidatorRequirements() {
    if (!this.formfournisseur.get('linkedin_link')?.value || this.formfournisseur.get('linkedin_link')?.value == '') {
      this.formfournisseur.get('website_link')?.setValidators([Validators.required, Validators.pattern(urlRegExp)])
      this.formfournisseur.get('website_link')!.updateValueAndValidity();
      this.formfournisseur.get('linkedin_link')?.clearValidators()
      this.formfournisseur.get('linkedin_link')?.updateValueAndValidity()
    }
    if (this.formfournisseur.get('website_link')?.value == '') {
      this.formfournisseur.get('linkedin_link')?.setValidators([Validators.required, Validators.pattern(linkedCompanyRegExp)])
      this.formfournisseur.get('linkedin_link')!.updateValueAndValidity();
      this.formfournisseur.get('website_link')?.clearValidators()
      this.formfournisseur.get('website_link')?.setValidators(Validators.pattern(urlRegExp))
      this.formfournisseur.get('website_link')?.updateValueAndValidity()
    }
  }
  /*download file add bulk */
  downloadCsv() {
    this.fournisseurservice.downloadcsvfileAddBulksupplier().subscribe({
      next: (res: Blob) => {
        console.log("res", res);
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'ajout en masse client fournisseur.csv');
      },
      error: (err) => {
        console.log('error', err);
        // Handle the error appropriately
      },
    });
  }
  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }

  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      console.log('Fichier sélectionné :', this.selectedFile);
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        console.log('selectedFile', fileExtension);
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }

  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('client_id', this.idclientConnected);
      this.spinner.show();
      this.fournisseurservice.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          console.log('file bluk error', this.fileBulkError);
          this.getbulkCandidate(this.fileBulkError);
          this.toastr.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastr.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastr.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              }
              // else {
              //   this.toastr.error(serverError);
              // }
            }
            // else {
            //   this.toastr.error(serverError);
            // }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.fournisseurservice.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastr.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error(serverError);
      },
    });
  }
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
      if (this.searchForm.dirty) {
        this.getListfournisseurs();
      } else if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){
        this.pagination = true
        this.getListfournisseurs();
      }
    }
  }
  sortData(item: string) {
    for (const iterator of headerColumns20) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listfournisseurs = this.sortDataService.sortArray(
        this.listfournisseurs,
        item,
        this.currentSortDirection
      );
    else this.getListfournisseurs();
  }
  sortType(e: any) {
    console.log(e.target.value);
    this.checkboxStates[e.target.value] = e.target.checked;
    this.type = e.target.value;
    this.searchForm.reset();
    this.currentPage=1;
    this.getListfournisseurs();
    this.showTab('kt_project_targets_table_pane');

  }
  showTab(paneId: string) {
    // Hide all tab panes
    const tabPanes = document.querySelectorAll('.tab-pane');
    tabPanes.forEach(pane => pane.classList.remove('active'));

    // Remove 'active' class from all tabs
    const tabs = document.querySelectorAll('.nav-item a');
    tabs.forEach(tab => tab.classList.remove('active'));

    // Show the selected tab pane
    const selectedPane = document.getElementById(paneId);
    if (selectedPane) {
      selectedPane.classList.add('active');
    }

    // Activate the corresponding tab
    const correspondingTab = document.querySelector(`a[href="#${paneId}"]`);
    if (correspondingTab) {
      correspondingTab.classList.add('active');
    }
  }
  getListfournisseurs() {
      this.spinner.show

    if (this.type.length === 0) {
      this.type = [];
    }
    if (this.type == 1) {
      let dataPyload =
        this.sortAttr == ''
          ? {
            type: this.type,
            clientFinal_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
          : {
            ...{
              type: this.type,
              clientFinal_id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
      console.log('dataPyload', dataPyload);

      this.fournisseurservice.getListFournisseuresn(dataPyload).subscribe({
        next: (response: any) => {
          this.isLoadSpinner = false;

          this.listfournisseurs = response.data.data

          this.typee =
            response.data.data[0]?.company?.client_final_e_s_n[0]?.type;
          this.totalItems = response.data.total;
          this.spinner.hide()

          console.log('list fournisseurs', this.listfournisseurs);
        },
        error: (error: any) => {
          this.spinner.hide()

          console.error('Error fetching fournisseurs: ', error);
        },
      });
    }

    else {
      let dataPyload =
        this.sortAttr == ''
          ? {
            clientFinal_id: this.idclientConnected,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
          : {
            ...{
              clientFinal_id: this.idclientConnected,
              per_page: this.itemsPerPage,
              page: this.currentPage,
            },
            ...{
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };

      console.log('dataPyload', dataPyload);

      this.fournisseurservice.getIndivListFournisseurr(dataPyload).subscribe({
        next: (response: any) => {
          this.isLoadSpinner = false;
          this.listfournisseurs = response.data.data
          // .slice(0, this.endIndex);
          this.typee = response.data?.data?.type;
          this.totalItems = response.data.total;
          this.spinner.hide()

          console.log('list fournisseurs', this.listfournisseurs);
        },
        error: (error: any) => {
          console.error('Error fetching fournisseurs: ', error);
        },
      });
      this.spinner.hide();
    }
  }

  createfournisseur() {
    this.setValidatorRequirements();
    if (this.isexiste == false) {
      this.setValidatorRequirements();
      this.enableFormFields();
      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
      let year_of_creation = '';
      if (this.formfournisseur.value.year_of_creation instanceof Date) {
        year_of_creation = this.formfournisseur.value.year_of_creation
          .getFullYear()
          .toString();
      } else {
        year_of_creation = this.formfournisseur.value.year_of_creation;
      }
      this.formfournisseur.patchValue({
        clientFinal_id: this.idclientConnected,
        year_of_creation: year_of_creation,
        type: 2,
      });
      const phone = this.phoneForm.get('phone')?.value;
      this.formfournisseur
        .get('related_phone_client')
        ?.setValue(phone?.internationalNumber);
        

      console.log('form', this.formfournisseur.value);
      this.fournisseurservice
        .createfournisseur(this.formfournisseur.value)
        .subscribe({
          next: (response) => {
            console.log('add fournisseur', response);
            this.toastr.success('fournisseur est ajouté avec succès');
            this.getListfournisseurs();
            this.closeModal();
          },
          error: (error: any) => {
            console.error('Error fetching add fournisseur123: ', error);
            if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.related_email_client &&
              error?.error.message?.related_email_client[0] ===
              'The related email client has already been taken.'
            ) {
              this.toastr.error("L'adresse email associée a déjà été utilisée !");
            } else if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.linkedin_link &&
              error?.error.message.linkedin_link[0] ===
              'The linkedin_link has already been taken.'
            ) {
              this.toastr.error('Fournisseur avec LinkedIn a déjà été pris !');
            } else if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.website_link &&
              error?.error.message.website_link[0] ===
              'The website link has already been taken.'
            ) {
              this.toastr.error('Fournisseur avec site web a déjà été pris !');
            } else if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.name &&
              error?.error.message.name[0] ===
              'The name has already been taken.'
            ) {
              this.toastr.error('Fournisseur avec Nom a déjà été pris !');
            }
            else if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.related_phone_client &&
              error?.error.message.related_phone_client[0] ===
              'The related phone client has already been taken.'
            ) {
              this.toastr.error('Le numéro de téléphone associé a déjà été utilisé. !');
            }

          },
        });
    }
     else {
      console.log('hello', this.isexiste);
      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
        const phone = this.phoneForm.get('phone')?.value;
      let data = {
        clientFinal_id: this.idclientConnected,
        fournisseur_id: this.fournisseur_id,
        nb_days: this.formfournisseur.value.nb_days,
        date_first_presentation:
          this.formfournisseur.value.date_first_presentation,
        related_first_name_client:
          this.formfournisseur.value.related_first_name_client,
        related_last_name_client:
          this.formfournisseur.value.related_last_name_client,
        
    related_phone_client: phone?.internationalNumber || this.formfournisseur.value.related_phone_client,
    
        related_email_client: this.formfournisseur.value.related_email_client,
        year_of_creation:this.formfournisseur.value.year_of_creation,
        type: 2,
      };
      this.fournisseurservice.createfournisseur(data).subscribe({
        next: (response) => {
          console.log('add fournisseur', response);
          this.toastr.success('Le fournisseur a été ajouté avec succès.');
          this.getListfournisseurs();
          this.closeModal();
        },
        error: (error) => {
          console.error('Error fetching add fournisseur: ', error);
          if (
            error?.error['message'] ===
            'supplier already associated to ClientFinal.'
          ) {
            this.toastr.error('fournisseur Déja Associé !');
            this.closeModal();
          }
        },
      });
    }
  }

  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.formfournisseur.get('address')?.setValue(null);
    }
  }

  createfournisseurindividuel() {
    if (!this.isexiste) {
      this.enableFormFields();
      this.formfournisseurind.markAllAsTouched();
      this.formfournisseurind.markAsDirty();
      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
      const phone = this.phoneForm.get('phone')?.value;
      console.log('my formmm', phone);

      this.formfournisseurind.patchValue({
        clientFinal_id: this.idclientConnected,
        year_of_creation: String(
          this.formfournisseurind.value.year_of_creation
        ),
        fournisseurPhone: phone?.internationalNumber,
        type: 5,
      });
      console.log('form', this.formfournisseurind.value);


      this.fournisseurservice
        .createfournisseur(this.formfournisseurind.value)
        .subscribe({
          next: (response) => {
            console.log('add fournisseur', response);
            this.toastr.success('fournisseur est ajouté avec succès');
            this.getListfournisseurs();
            this.closeModal();
          },
          error: (error: any) => {
           

            if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.email &&
              error?.error.message?.email[0] ===
              'The email has already been taken.'
            ) {
              this.toastr.error('Fournisseur Déjà Associé !');
            } else if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.linkedin_link &&
              error?.error.message.linkedin_link[0] ===
              'The linkedin link has already been taken.'
            ) {
              this.toastr.error('Fournisseur avec LinkedIn a déjà été pris !');
            }

            if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.fournisseur_email &&
              error?.error.message.fournisseur_email[0] ===
              'The fournisseur_email has already been taken.'
            ) {
              this.toastr.error(
                'Fournisseur avec email  personnel a déjà été pris !'
              );
            }
            if (
              error?.error &&
              error?.error?.message &&
              error?.error.message?.fournisseurPhone &&
              error?.error.message.fournisseurPhone[0] ===
              'The fournisseur phone has already been taken.'
            ) {
              this.toastr.error('Le numéro de téléphone associé a déjà été utilisé. !');

            }
          },
        });
    } 
    else {
      this.idclientConnected =
        this.localStorageService.getData('clientConnected');
      this.isexiste = false;
      let data = {
        clientFinal_id: this.idclientConnected,
        fournisseur_id: this.fournisseur_id,
        nb_days: this.formfournisseur.value.nb_days,
        date_first_presentation: this.formfournisseur.value.date_first_presentation,
        type: 5,
      };
      // this.disableFormFieldsIndiv();
      this.fournisseurservice.createfournisseur(data).subscribe({
        next: (response) => {
          console.log('add fournisseur', response);

          this.toastr.success('Le fournisseur a été ajouté avec succès.');
          this.getListfournisseurs();
          this.closeModal();
        },
        error: (error) => {
          console.error('Error fetching add fournisseur: ', error);
          if (
            error?.error['message'] ===
            'supplier already associated to ClientFinal.'
          ) {
            this.toastr.error('fournisseur Déja Associé !');
            this.closeModal();
            this.isexiste = false;
          }
        },
      });
    }
  }
  updateSupplier() {
    this.formfournisseur.get('fournisseur_id')?.setValue(this.idSupplier);
    this.formfournisseur.get('client_id')?.setValue(this.idclientConnected);
    let year_of_creation = '';
    if (this.formfournisseur.value.year_of_creation instanceof Date) {
      year_of_creation = this.formfournisseur.value.year_of_creation
        .getFullYear()
        .toString();
    } else {
      year_of_creation = this.formfournisseur.value.year_of_creation;
    }
    const phone =  this.formfournisseur.get('related_phone_client')?.value
    this.formfournisseur
    .get('related_phone_client')
    ?.setValue( phone?.internationalNumber);
    this.formfournisseur.patchValue({
      year_of_creation: year_of_creation,
    });
    this.fournisseurservice
      .updateFournisseur(this.formfournisseur.value)
      .subscribe({
        next: (response) => {
          console.log('update fournisseur', response);
          this.toastr.success('Le fournisseur a été modifié avec succès.');
          this.getListfournisseurs();
          this.closeModal();
        },
        error: (error) => {
          console.error('Error updating fournisseur: ', error);
          if (
            error?.error?.message ===
            'supplier already associated to ClientFinal.'
          ) {
            this.toastr.error('fournisseur déjà associé !');
          } else {
            this.toastr.error(
              "Une erreur s'est produite lors de la mise à jour du fournisseur."
            );
          }
          this.closeModal();
        },
      });
  }

  updateSupplierindiv() {
    this.formfournisseurind.get('fournisseur_id')?.setValue(this.idSupplier);
    this.formfournisseurind.get('client_id')?.setValue(this.idclientConnected);
    this.formfournisseurind
      .get('clientFinal_id')
      ?.setValue(this.idclientConnected);
    this.fournisseurservice
      .updatefournisseurind(this.formfournisseurind.value)
      .subscribe({
        next: (response) => {
          console.log('add fournisseur', response);
          // Swal.fire('fournisseur est ajouté avec succés ');
          this.toastr.success('Le fournisseur a été modifié avec succès.');
          this.getListfournisseurs();
          this.closeModal();
        },
        error: (error) => {
          console.error('Error fetching add fournisseur: ', error);
          if (
            error?.error['message'] ===
            'supplier already associated to ClientFinal.'
          ) {
            this.toastr.error('fournisseur Déja Associé !');
            this.closeModal();
          }
        },
      });
  }
  close_modal_add() {
    this.isexiste = false;
    let btnClose = document.getElementById('ModalClose_add_fournisseur');

    if (btnClose) {
      btnClose.click();
    }
    this.enableFormFields();
    this.enableFormFieldsIndiv();
    this.formfournisseurind.reset();
    this.formfournisseur.reset();
    this.phoneForm.reset();
  }
  getfournisseurByName(event: any) {
    console.log('event', event.target.value);
    this.formfournisseur.patchValue({
      linkedin_link: '',
      website_link: '',
      year_of_creation: '',
      domain: '',
      type: '',
      fournisseur_id: '',
      ContactEmail: '',
    });
    this.enableFormFields()
    this.fournisseurservice.getfournisseurbyname(event.target.value, this.idclientConnected).subscribe({
      next: (res) => {
        if (res.status === 200) {
          console.log('reponse', res);
          if(res.data.id){
          this.isexiste = true;
          this.fournisseur_id = res.data.id;
          this.formfournisseur.patchValue({
            linkedin_link: res.data.linkedin_link,
            website_link: res.data.website_link,
            year_of_creation: res.data.year_of_creation,
            domain: res.data.domain,
            address:res.data.city,
            country:res.data.country,
            type: res.data.type,
            fournisseur_id: res.data.id,
            ContactEmail: res.data.ContactEmail,
          });
          this.disableFormFields();
        }
        else{
          this.isexiste = false;
          this.formfournisseur.patchValue({
            linkedin_link: '',
            website_link: '',
            year_of_creation: '',
            domain: '',
            type: '',
            fournisseur_id: '',
            ContactEmail: '',
          });
        }
        }
      },
      error: (error) => {
        console.log(error);
     
      },
    });
  }
  clearForm(): void {
    this.isexiste = false;
    this.formfournisseur.patchValue({
      linkedin_link: '',
      website_link: '',
      year_of_creation: '',
      domain: '',
      type: '',
      fournisseur_id: '',
      ContactEmail: '',
    });
    this.disableFormFields(); // Disable the fields when form is cleared
  }
  
  // clearForm(): void {
  //   this.isexiste = false;
  //   this.formfournisseur.patchValue({
  //     linkedin_link: '',
  //     website_link: '',
  //     year_of_creation: '',
  //     domain: '',
  //     type: '',
  //     fournisseur_id: '',
  //     ContactEmail: '',
  //   });
  // }
  
  onSearch(event: any): void {
    const term = event.target.value.trim();
    this.searchTerms.next(term); // Emit the current search term
    // this.enableFormFields();
  }
  // onSearch(event: any): void {
  //   const term = event.target.value.trim();
  
  //   // Check if the search term is not just spaces or empty
  //   if (term.length > 0) {
  //     this.searchTerms.next(term); // Emit the current search term
  //     this.enableFormFields();
  //   } else {
  //     this.clearForm(); // Reset form if the input is invalid (only spaces)
  //     this.disableFormFields();
  //   }
  // }
  
  searchMail() {
    const id = this.localStorageService.getData('clientConnected');

    this.searchInputSubject
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((searchEmail) => {



          return this.fournisseurservice.getfournisseurbyemail(searchEmail, id).pipe(
            catchError((error) => {
              console.log('my error ', error)
              this.enableFormFieldsIndiv();
              this.phoneForm.get('phone')?.enable();
              this.phoneForm.patchValue({ phone: '' })
              this.formfournisseurind.patchValue({
                linkedin_link: '',
                type: '',
                fournisseur_id: '',
                ContactEmail: '',
                fournisseur_last_name: '',
                fournisseur_first_name: '',
                fournisseurPhone: '',

              });
              if (error.error.message === "already associated to this client as salary") {
                this.toastr.error(salaryalreadyassociated);
              }
              if (error.error.message === "fournisseur already associated to this client") {
                this.toastr.error(suplieralreadyassociated);
              }
              if (error.error.message === "already associated to this client as employee") {
                this.toastr.error(emplyeealreadyassociated);
              }
              if (error.error.message === "already associated to this client as consultant externe") {
                this.toastr.error(consultantalreadyassociated);
              }
              return [];

            })
          );
        })
      )
      .subscribe({
        next: (res) => {
          if (res.status === 200) {
            this.spinner.hide();

            console.log('reponse', res);
            this.isexiste = true;
            this.fournisseur_id = res.data.id;
            this.formfournisseurind.patchValue({
              linkedin_link: res.data.linkedin_link,
              type: res.data?.type,
              fournisseur_id: res.data?.id,
              ContactEmail: res.data?.ContactEmail,
              fournisseur_last_name: res.data?.last_name,
              fournisseur_first_name: res.data?.first_name,
              fournisseurPhone: res.data?.phone_number,

            });
            this.phoneForm.get('phone')?.setValue(res.data?.phone_number)

            this.disableFormFieldsIndiv();
          }
        },

      });
  }
  applyFilterEmail(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchInputSubject.next(filterValue);
  }
  disableFormFields() {
    if (this.formfournisseur) {
      this.formfournisseur.get('linkedin_link')?.disable();
      this.formfournisseur.get('website_link')?.disable();
      this.formfournisseur.get('country')?.disable();
      this.formfournisseur.get('address')?.disable();
      this.formfournisseur.get('year_of_creation')?.disable();
    }
  }

  disableFormFieldsUpdate() {
    if (this.formfournisseur) {
      this.formfournisseur.get('name')?.disable();
      this.formfournisseur.get('ContactEmail')?.disable();
      this.formfournisseur.get('country')?.disable();
      this.formfournisseur.get('address')?.disable();
      this.formfournisseur.get('year_of_creation')?.disable();
      this.formfournisseur.get('linkedin_link')?.disable();
      this.formfournisseur.get('website_link')?.disable();
    }
  }
  enableFormFieldsUpdate() {
    if (this.formfournisseur) {
      this.formfournisseur.get('name')?.enable();
      this.formfournisseur.get('ContactEmail')?.enable();
      this.formfournisseur.get('country')?.enable();
      this.formfournisseur.get('address')?.enable();
      this.formfournisseur.get('year_of_creation')?.enable();
      this.formfournisseur.get('linkedin_link')?.enable();
      this.formfournisseur.get('website_link')?.enable();
    }
  }


  disableFormFieldsIndiv() {
    if (this.formfournisseurind) {
      this.formfournisseurind.get('linkedin_link')?.disable();
      this.formfournisseurind.get('fournisseur_first_name')?.disable();
      this.formfournisseurind.get('fournisseur_last_name')?.disable();
      this.phoneForm.get('phone')?.disable();
    }
  }
  enableFormFieldsIndiv() {
    if (this.formfournisseur) {
      this.formfournisseurind.get('linkedin_link')?.enable();
      this.formfournisseurind.get('fournisseur_first_name')?.enable();
      this.formfournisseurind.get('fournisseur_last_name')?.enable();
      this.formfournisseur.get('fournisseurPhone')?.enable();
      this.phoneForm.get('phone')?.enable();

    }
  }
  enableFormFields() {
    if (this.formfournisseur) {
      this.formfournisseur.get('linkedin_link')?.enable();
      this.formfournisseur.get('website_link')?.enable();
      this.formfournisseur.get('country')?.enable();
      this.formfournisseur.get('address')?.enable();
      this.formfournisseur.get('year_of_creation')?.enable();
    }
  }
  getfournisseurById(id: any) {
    this.fournisseurservice.getUserById(id).subscribe({
      next: (res: any) => {
        console.log('detail fournisseur', res);
        this.detailfournisseur = res.data;
        console.log('detail fournisseur', this.detailfournisseur);
      },
      error: (error) => {
        console.error('Error detail fournisseur: ', error);
      },
    });
  }
  getesnwithconsultant() {
    let data = {
      id: 1,
      per_page: this.itemsPerPage,
      page: this.currentPage,
      sort: this.currentSortDirection,
    };
    this.fournisseurservice.getesnwithconsultant(data).subscribe({
      next: (response: any) => {
        console.log('rep', response);
        if (response.data && response.data.data) {
          // this.listfournisseurs = response.data.data;
          // this.totalItems = response.data.total;
          // console.log('list fournisseurs', this.listfournisseurs);
        }
      },
      error: (error: any) => {
        console.error('Error fetching esn with consultant: ', error);
      },
    });
  }
  profilEsnNavigation(id: string, type: any) {
    let routeType: string;
  
    if (type == 2) {
      routeType = 'esn';
    } else if (type == 3) {
      routeType = 'client final';
    } else if (type == 4) {
      routeType = 'cabinet de recrutement';
    } else {
      routeType = ''; // Si aucune condition n'est remplie
    }
  
    console.log('id company', id);
    this.router.navigate(['/detailcompany', id, routeType]);
  }
  
  profilFourNavigation(id: string) {
    console.log('id company', id);
    this.router.navigate(['/detailcompany/' + id + '/' + 'fournisseur']);
  }
  resetform() {
    this.formfournisseur.reset();
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      consultant_name: [data?.consultant_name?data?.consultant_name: ''],
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  openModaladd(template: TemplateRef<any>, dataa?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.enableFormFields();
  }

  openModal(template: TemplateRef<any>, dataa?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.idSupplier = dataa?.company?.id;
    this.formfournisseur.get('name')?.setValue(dataa?.company?.name);
    this.formfournisseur
      .get('linkedin_link')
      ?.setValue(dataa.company.linkedin_link);
    this.formfournisseur
      .get('website_link')
      ?.setValue(dataa.company.website_link);
      const yearOfCreation = dataa.company.year_of_creation;
      if (isNaN(yearOfCreation) || yearOfCreation == null) {
        this.formfournisseur.get('year_of_creation')?.setValue('');
      } else {
        this.formfournisseur.get('year_of_creation')?.setValue(yearOfCreation);
      }
    this.formfournisseur.get('country')?.setValue(dataa.company.country);
    this.formfournisseur.get('address')?.setValue(dataa.company.city);
    this.formfournisseur
      .get('related_first_name_client')
      ?.setValue(dataa.company.client_final_e_s_n[0].related_first_name_client);
    this.formfournisseur
      .get('related_last_name_client')
      ?.setValue(dataa.company.client_final_e_s_n[0].related_last_name_client);
    this.formfournisseur
      .get('related_email_client')
      ?.setValue(dataa.company.client_final_e_s_n[0].related_email_client);
    this.formfournisseur
      .get('related_phone_client')
      ?.setValue(dataa.company.client_final_e_s_n[0].related_phone_client);
    this.formfournisseur
      .get('nb_days')
      ?.setValue(dataa.company.client_final_e_s_n[0].nb_days);
    this.formfournisseur
      .get('date_first_presentation')
      ?.setValue(dataa.company.client_final_e_s_n[0].date_first_presentation);
      this.disableFormFieldsUpdate()
    console.log('this updateform : ', this.formfournisseur);
  }
  openModaladdindiv(template: TemplateRef<any>, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.formfournisseurind.reset();
    this.enableFormFieldsIndiv()

  }
  openModalindi(template: TemplateRef<any>, dataa?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.idSupplier = dataa?.company?.id;
    this.formfournisseurind = this.createFormindivi(dataa.company);
    console.log('this openfournisseurindividuel : ', this.formfournisseurind);
    this.formfournisseur
      .get('fournisseur_first_name')
      ?.setValue(dataa?.company?.fournisseur_first_name);
    this.formfournisseur
      .get('fournisseur_last_name')
      ?.setValue(dataa?.company?.fournisseur_last_name);
    this.formfournisseur
      .get('linkedin_link')
      ?.setValue(dataa.company.linkedin_link);
    this.formfournisseur
      .get('fournisseur_email')
      ?.setValue(dataa.company.fournisseur_email);
    this.formfournisseur
      .get('fournisseurPhone')
      ?.setValue(dataa.company.fournisseurPhone);
    this.formfournisseur.get('address')?.setValue(dataa.company.address);
    this.formfournisseur
      .get('nb_days')
      ?.setValue(dataa.company.client_final_e_s_n[0].nb_days);
    this.formfournisseur
      .get('date_first_presentation')
      ?.setValue(dataa.company.client_final_e_s_n[0].date_first_presentation);
  }
  searchfournisseur() {
    console.log('typesearch', this.type,this.searchForm.value);
    let valueForm = this.searchForm.value;
    let consultant_name = '';
   
    if (this.type == 1) consultant_name = "consultant_name";
    else consultant_name = "user_name";

    let data = {
      [consultant_name]: valueForm.consultant_name? valueForm.consultant_name:"",
      clientFinal_id: this.idclientConnected?this.idclientConnected:"",
      name: valueForm.name?valueForm.name:"",
      type: [this.type],
      per_page: this.itemsPerPage,
      page: this.currentPage,
      search: this.transformSearch(valueForm.search),
    };
    console.log('data', data);
    this.spinner.show();
    this.fournisseurservice.searchfournisseur(data).subscribe({
      next: (resSearch) => {
        if (!resSearch.data.data.length && this.currentPage > 1) {
          this.currentPage = 1;
          this.searchfournisseur();
          console.log('response search', resSearch);
          this.spinner.hide();
        } else {
          this.listfournisseurs = resSearch.data.data.slice(0, this.endIndex);
          this.totalItems = resSearch.data.total;
          this.spinner.hide();
        }
      },
      error: (error) => {
        console.log(error);
        // this.toastr.error(serverError);
        this.spinner.hide();
      },
    });
  }
  transformSearch(search: string): string {
    if(search ==null) {
      search =''
    }
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    // Ajoute des espaces autour des opérations logiques pour éviter des conflits avec les mots
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    // Remplace les termes entre guillemets doubles par les mêmes termes sans modification
    // et échappe les guillemets simples à l'intérieur des termes non compris entre guillemets
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    // Supprime les espaces en double pour une meilleure lisibilité
    search = search.replace(/\s+/g, ' ');
    console.log('alll',search.trim())

    // Renvoie la chaîne de recherche transformée
    return search.trim();
  }
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.searchfournisseur();
  }
  getYearFromDate(date: Date): number {
    return date.getFullYear();
  }
  afficherAnnees() {
    this.annees = [];

    if (this.annee) {
      const anneeActuelle = new Date().getFullYear();
      for (let i = this.annee; i <= anneeActuelle; i++) {
        this.annees.push(i);
      }
    }
  }

  redirectToSite(website_link: string): void {
    window.open(website_link, '_blank');
  }
  getListElementHeader() {
    this.fournisseurservice
      .getHeaderElementssalariecf(23)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.dataHeader = res.data;
          for (const iterator of this.dataHeader) {
            if (
              (iterator.checked == 'oui' && !iterator.checked_user) ||
              (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
              (iterator.checked == 'oui' && iterator.checked_user == 'oui')
            )
              this.listNames.push(iterator.name);
          }
          this.dataHeader.map((el: any) => {
            if (
              (el.checked == 'oui' && !el.checked_user) ||
              (el.checked_user == 'oui' &&
                (el.checked == 'non' || el.checked == 'oui'))
            ) {
              return (el.checkAdmin = true);
            } else {
              return (el.checkAdmin = false);
            }
          });
        },
        error: () => { },
      });
  }

  changeSelectionElement(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    let payload = {
      sub_page_id: data?.id,
    };
    this.fournisseurservice
      .changeDelectedElementHeadesalariecf(payload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => { },
        error: () => { },
      });
  }
  dissociateSupplier(id: string, type: string) {


    if (type === 'indiv') {
      this.dataFourn = {
        client_id: this.idclientConnected,
        user_id: id
      }
    }
    else {
      this.dataFourn = {
        client_id: this.idclientConnected,
        fournisseurEsn_id: id
      }
    }
    // let formdata = new FormData();
    // formdata.append('esn_id', this.idclientConnected);
    // formdata.append('candidate_id', id);
    // console.log('formdata', formdata);
    Swal.fire({
      title: `Voulez-vous vraiment ${this.type == 1 ? "supprimer" : "dissocier"} ce fournisseur ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Oui, ${this.type == 1 ? "supprimer" : "dissocier"} !`,
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.fournisseurservice
          .dissocierEsn(id, this.idclientConnected, type, this.type)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res: any) => {
              this.toastrService.success('Vous avez supprimé ce fournisseur avec succès.');
              // window.location.reload()
              this.searchfournisseur()
              this.spinner.hide();
            },
            error: () => {
              this.spinner.hide();
            },
          });
      }
    });
  }

}
